import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const CurvedElement = ({elementType, alignment = '', children, color}) => {

	if (!elementType) return null;
	
	return (
		<CurvedElementContainer className={`align--${alignment} ${elementType}`}
			color={color}
		>
			<TopCurveSvg
				viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg">
				<path d="M19.5 0C19.5 9.56705 9.56705 16.2356 0 16.2356H19.5V0Z" fill="currentColor" />
			</TopCurveSvg>
			{ children }
			<BottomCurveSvg
				viewBox="0 0 22 29" xmlns="http://www.w3.org/2000/svg">
				<path d="M21.7256 0V28.5H9.15527e-05C12.9861 28.5 21.7256 12.986 21.7256 0Z" fill="currentColor"/>
			</BottomCurveSvg>
		</CurvedElementContainer>
	)
};

CurvedElement.propTypes = {
	elementType: PropTypes.string.isRequired,
	alignment: PropTypes.string,
	children: PropTypes.object,
	color: PropTypes.string,
};

export default CurvedElement;

const TopCurveSvg = styled.svg`
	position: absolute;
	top: -3.1rem;
	right: -0.5rem;
	height: 3rem;
	transform: rotate(90deg) scaleY(-1);
`;

const BottomCurveSvg = styled.svg`
	position: absolute;
	bottom: -0.05rem;
	left: -2.5rem;
	height: 3.5rem;
`;

const CurvedElementContainer = styled.div`
	position: absolute;
	bottom: -0.05rem;
	right: 0rem;
	background-color: ${props => props.color};
	display: inline-block;
	color: ${props => props.color};

	&.circle-button {
		padding: 1rem 0 0 1rem;
		border-radius: 55% 0 0 0;
	}

	&.text-button {
		padding: 3.4rem 1rem 0 3.4rem;
		border-radius: 6rem 0 0 0;
	}

	&.align--left {
		left: 0rem;
		right: unset;

		&.circle-button {
			padding: 2rem 2rem 0 1rem;
			border-radius: 0 50% 0 0;	
		}

		&.text-button {
			padding: 3.4rem 3.4rem 0 1rem;
			border-radius: 0 6rem 0 0;
		}

		${TopCurveSvg} {
			left: -0.1rem;
			transform: scaleX(-1);
			right: unset;
		}

		${BottomCurveSvg} {
			right: -2.6rem;
			left: unset;
			transform: scaleX(-1);
		}
	}
`;


